import { RiskFactorCell, InputCell, RiskRatingCell } from './TableCells';

export const riskTableColumns = [
  {
    id: 'riskFactor',
    header: 'Risk Factor',
    accessorKey: 'name',
    cell: RiskFactorCell,
  },
  {
    id: 'input',
    header: 'Input',
    accessorKey: 'input',
    cell: InputCell,
  },
  {
    id: 'riskOutput',
    header: 'Risk Rating',
    accessorKey: 'riskOutput',
    size: 100,
    meta: {
      disableFlex: true,
    },
    cell: RiskRatingCell,
  },
];
